<template>
  <div>
    <v-row>
      <v-container class="pa-0" fluid>
        <v-row dense class="mx-2 py-0">
          <v-col cols="12" md="10" class="py-0">
            <v-row justify="start">
              <v-col cols="2" class="pb-0">
                <v-select label="Unidad" v-model="uniEje" :items="unidades" dense
                  item-text="texto" hide-details item-value="value"></v-select>
              </v-col>
              <v-col cols="2" class="pb-0">
                <v-select label="Ambito" v-model="ambito" :items="ambitos" dense
                  item-text="texto" hide-details item-value="value"></v-select>
              </v-col>
              <v-col cols="2" class="pb-0">
                <v-select label="Coord. Estatal" v-model="coordEst" :items="coordsEst" dense
                  item-text="texto" hide-details item-value="value"></v-select>
              </v-col>
              <v-col cols="2" class="pb-0">
                <date-picker label="Del" :date.sync="fecIni" :rules="perRules" alldays="true"></date-picker>
              </v-col>
              <v-col cols="2" class="pb-0">
                <date-picker label="Al" :date.sync="fecFin" :rules="perRules" alldays="true"></date-picker>
              </v-col>
              <v-col cols="2" class="pb-0">
                <v-tooltip bottom activator="#btn-reload">
                  <span>Cargar</span>
                </v-tooltip>
                <v-btn id="btn-reload" icon @click="load()">
                  <v-icon >mdi-refresh</v-icon>
                </v-btn>
                <v-tooltip bottom activator="#btn-download">
                  <span>Descargar</span>
                </v-tooltip>
                <v-btn id="btn-download" icon :disabled="disabledDownload" @click="descargar()">
                  <v-icon >mdi-download</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-row>
    <v-row dense class="pt-0 mx-2">
      <v-col cols="12" md="6" class="pt-0 mt-0">
        <v-radio-group class="pt-0 mt-0" dense hide-details v-model="estatus" row @change="load()">
          <v-radio label="Aplicado" value="4"></v-radio>
          <v-radio label="Cancelado" value="6"></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row dense justify="center" class="pt-0">
      <v-col cols="12">
        <v-data-table
          :headers="header"
          :items="aplicados"
          :options.sync="options"
          :footer-props="footerProps"
          :server-items-length="totalRegs"
          :items-per-page.sync="regsPerPage"
          :page="page"
          disable-sort
          :loading="loading"
          dense
          class="elevation-2"
        >
          <template v-slot:item.nombres="{ item }">
            {{ nombreCompleto(item) }}
          </template>
          <template v-slot:item.vigenciaIni="{ item }">
            <span>{{ formatFec(item.vigenciaIni) }}</span>
          </template>
          <template v-slot:item.vigenciaFin="{ item }">
            <span>{{ formatFec(item.vigenciaFin) }}</span>
          </template>
          <template v-slot:item.fechaReg="{ item }">
            <span>{{ formatFec(item.fechaReg) }}</span>
          </template>
          <template v-slot:item.observaciones="{ item }">
            <span v-if="haveMore(item.observaciones)" >
              {{ formatObserva(item.observaciones) }}
              <span class="text-caption success--text" @mouseover.capture.stop="showObserva($event, item.observaciones)" @mouseleave.capture.stop="hideObserva()">
                mas
              </span>
            </span>
            <span v-else>
              {{ item.observaciones }}
            </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-menu :value="verObserva" :position-x="posX" :position-y="posY">
      <v-card width="400" flat>
        <v-card-text class="pa-2">
            <span class="font-weight-medium">{{mensajeObserva}}</span>
        </v-card-text>
      </v-card>
    </v-menu>

    <dialog-message :show.sync="showDialog" :color="colorDlg" :title="titleDlg">
      {{ mensaje }}
    </dialog-message>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import DialogMessage from "@/components/dialogs/DialogMessage.vue";
import DatePicker from "@/components/dialogs/DatePicker.vue";
import AccesosUtils from "@/utils/AccesosUtils.js";
import {LocalDate, nativeJs} from '@js-joda/core';

export default {
  components: {
    DialogMessage,
    DatePicker
  },
  data() {
    return {
      accesosUtils: new AccesosUtils(),
      uniEje: null,
      coordEst: null,
      ambito: null,
      fecIni: null,
      fecFin: null,
      estatus: "4",
      perRules: [v => !!v || "Fecha"],
      unidades: [],
      coordsEst: [],
      ambitos: [],
      totalRegs: 0,
      regsPerPage: 10,
      page: 1,
      aplicados: [],
      header: [
        { text: 'curp', value: 'curp', class: "accent white--text"},
        { text: 'Nombre', value: 'nombres', class: "accent white--text"},
        { text: 'vig Ini', value: 'vigenciaIni', class: "accent white--text"},
        { text: 'Vig Fin', value: 'vigenciaFin', class: "accent white--text"},
        { text: 'Justificante', value: 'justificante', class: "accent white--text"},
        { text: 'Fec Apli', value: 'fechaReg', class: "accent white--text"},
        { text: 'Observaciones', value: 'observaciones', class: "accent white--text"},
      ],
      options: {},
      footerProps: {
        itemsPerPageOptions: [5, 10, 15],
        showFirstLastPage: true
      },
      loading: false,
      showDialog: false,
      colorDlg: "primary",
      titleDlg: "",
      mensaje: null,
      overlay: false,
      disabledDownload: false,
      inicializado: false,
      posX: 0,
      posY: 0,
      verObserva: false,
      mensajeObserva: null,
      observer: false
    }
  },
  computed: {
    ...mapState(['usuario'])
  },
  watch: {
    uniEje() {
      if (this.inicializado && this.uniEje && this.observer) {
        this.updateAmbitos();
      }
    },
    ambito() {
      if (this.inicializado && this.observer) {
        this.updateCoordEst();
      }
    },
    options() {
      if (this.observer) {
        const { page, itemsPerPage } = this.options;
        this.page = page;
        this.itemsPerPage = itemsPerPage;
        this.loadAplicados(page, itemsPerPage);
      }
    }
  },
  methods: {
    async loadAccesos() {
      let self = this;
      await this.accesosUtils.loadAccesos(this.usuario, (unidades, ambitos, ces) => {
        self.observer = false;
        self.unidades = unidades;
        self.ambitos = ambitos;
        self.coordsEst = ces;
        self.observer = true;
      });
    },
    updateAmbitos() {
      let self = this;
      this.accesosUtils.loadAccesosUniEje(this.uniEje, (ambitos, ces) => {
        self.observer = false;
        self.ambitos = ambitos;
        if (ambitos && ambitos.length > 0) {
          self.ambito = ambitos[0].value;
        }
        self.coordsEst = ces;
        if (ces && ces.length > 0) {
          self.coordEst = ces[0].value;
        }
        self.observer = true;
      });
    },
    updateCoordEst() {
      let self = this;
      this.accesosUtils.loadAccesosAmb(this.uniEje, this.ambito, (ces) => {
        self.coordsEst = ces;
        if (ces && ces.length > 0) {
          self.coordEst = ces[0].value;
        }
      });
    },
    validaPeriodo() {
      let ok = false;
      if (this.fecIni && this.fecFin) {
        let ldIni = LocalDate.from(nativeJs(this.fecIni));
        let ldFin = LocalDate.from(nativeJs(this.fecFin));
        //ok = this.fecFin.getTime() >= this.fecIni.getTime();
        ok = ldIni.compareTo(ldFin) <= 0;
        if (ok) {
          const dife = 31* 24* 60* 60* 1000; // El periodo maximo permitido sera de 31 dias
          if ((this.fecFin.getTime()- this.fecIni.getTime()) > dife) {
            ok = false;
            this.mensaje = "El periodo maximo permitido es de 1 mes.";
          }
        } else {
          this.mensaje = "El periodo es incorrecto.";
        }
      }
      return ok;
    },
    async loadAplicados(pagina, regs) {
      if (!this.validaPeriodo()) {
        this.showError(this.mensaje);
        return;
      }
      let self = this;
      this.loading = true;
      let perIni = this.fecToYMD(this.fecIni);
      let perFin = this.fecToYMD(this.fecFin);
      try {
        const response = await axios.get(`/aplicadossia/${this.estatus}?uniEje=${this.uniEje}&ce=${this.coordEst}&amb=${this.ambito}&perIni=${perIni}&perFin=${perFin}&pagina=${pagina}&regs=${regs}`);
        self.loading = false;
        let datos = response.data;
        self.totalRegs = datos.totalRegs;
        self.aplicados = datos.aplicados;
        self.disabledDownload = false;
        return "";
      }catch(error) {
        self.loading = false;
        if (error.response) {
          self.showError(error.response.data);
        } else {
          console.log(error);
          self.showError("No se pudo ejecutar el proceso.")
        }
        return "";
      }
    },
    descargar() {
      if (!this.validaPeriodo()) {
        this.showError("El periodo es incorrecto.");
        return;
      }
      let self = this;
      this.overlay = true;
      let perIni = this.fecToYMD(this.fecIni);
      let perFin = this.fecToYMD(this.fecFin);
      axios.get(`/aplicadossia/download/${this.estatus}?uniEje=${this.uniEje}&ce=${this.coordEst}&amb=${this.ambito}&fecIni=${perIni}&fecFin=${perFin}`)
      .then(response => {
        let servlet = response.data;  // Regresa la URL para descargar el archivo.
        let href = window.location.href;
        let pos = href.search("mcad");
        let url;
        if (pos < 0) {
          url = 'http://localhost:8086/mcad'+ servlet; // Para pruebas en desarrollo
        } else {
          url = href.substr(0, pos)+ "mcad"+ servlet;
        }
        location.href = url; // Descargar el archivo
        self.overlay = false;
      })
      .catch(error => {
        self.overlay = false;
        if (error.response) {
          self.showError(error.response.data);
        } else {
          console.log(error);
          self.showError("No se pudo ejecutar el proceso.")
        }
      });
    },
    load() {
      this.page = 1;
      this.loadAplicados(this.page, this.regsPerPage);
    },
    async init() {
      await this.loadAplicados(this.page, this.regsPerPage);
      await this.loadAccesos();
    },
    nombreCompleto(item) {
      let nom = "";
      if (item.apellidoPat) {
        nom += item.apellidoPat+ " ";
      }
      if (item.apellidoMat) {
        nom += item.apellidoMat+ " ";
      }
      nom += item.nombres;
      return nom;
    },
    formatObserva(observa) {
      let ver = "";
      if (observa) {
        if (observa.length > 45) {
          ver = observa.substr(0, 42)+ "...";
        } else {
          ver = observa;
        }
      }
      return ver;
    },
    haveMore(observa) {
      let hay = observa && observa.length > 45;
      return hay;
    },
    showObserva(event, mensaje) {
      if (!this.verObserva) {
        this.posX = event.clientX+ 30;
        this.posY = event.clientY;
        this.mensajeObserva = mensaje;
        this.verObserva = true;
      }
    },
    hideObserva() {
      if (this.verObserva) {
        this.mensajeObserva = null;
        this.verObserva = false;
      }
    },
    showError: function (message) {
      this.mensaje = message;
      this.colorDlg = "error";
      this.titleDlg = "Error",
      this.showDialog = true;
    },
    showInfo: function (message) {
      this.mensaje = message;
      this.colorDlg = "primary";
      this.titleDlg = "Aviso",
      this.showDialog = true;
    },
    formatFec(fecha) {
      if (!fecha) return ""
      const [year, month, day] = fecha.substr(0,10).split('-');
      return `${day}/${month}/${year}`
    },
    fecToYMD(fecha) {
      if (!fecha) return ""
      const [year, month, day] = fecha.toISOString().substr(0,10).split('-');
      return `${year}${month}${day}`
    }
  },
  mounted() {
    this.uniEje = this.usuario.unidadEjecutora;
    this.ambito = this.usuario.ambito;
    this.coordEst = this.usuario.coordEstatal.toString();
    this.fecFin = new Date();
    const milis = this.fecFin- (7* 24* 60* 60* 1000);
    this.fecIni = new Date(milis);
    this.init();
    this.inicializado = true;
  }
}
</script>